import React, { useEffect } from "react";
import EventoVisualizarController from "../controller/evento-visualizar.controller";
import If from "../../../../../vendors/components/If";
import { Card } from "primereact/card";
import Container from "../../../../../vendors/components/Container";
import Field from "../../../../../vendors/components/Field";
import { InputText } from "primereact/inputtext";
import AnttButton from "../../../../../vendors/components/Button";
import ContribuicaoPublicadaController from "../controller/contribuicao-publicada.controller";
import ContribuicaoItem from "../../../../components/contribuicao/ContribuicaoItem";
import EventoContribuicaoFormController from "../controller/evento-contribuicao-form.controller";

interface Props {
  controller: EventoVisualizarController;
  rollBackUrl: any;
}

export default function ContribuicaoPublicada({
  controller,
  rollBackUrl,
}: Props) {
  const controllerContribuicao = new EventoContribuicaoFormController();
  const contribuicaoPublicadaController = new ContribuicaoPublicadaController();

  useEffect(() => {
    if (controller.tab === "contribuicao-publicada") {
      contribuicaoPublicadaController.obterContribuicoesPublicadas(
        controller.getId()
      );
      return;
    }
  }, [controller.tab]);

  const contribuicaoPublicadaItem = (m: any) => {
    if (!m.contribuicao || m.contribuicao.length === 0) {
      return (
        <>
          <Card
            header={
              <div>
                <strong dangerouslySetInnerHTML={{ __html: m.dsDispositivo ?? "" }} />
              </div>
            }
          >
            <label>Sem contribuições publicadas</label>
          </Card>
        </>
      );
    }
    return (
      <>
        <Card
          header={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
              }}
            >
              <div>
                <strong
                  dangerouslySetInnerHTML={{ __html: m.dsDispositivo ?? "" }}
                />
              </div>
              <div>
                <label
                  style={{ color: "var(--azul-primario)", marginRight: "10px" }}
                >
                  {m.contribuicao.length}
                  <span>
                    {m.contribuicao.length > 1 || m.contribuicao.length == 0
                      ? " contribuições"
                      : " contribuição"}
                  </span>
                </label>
              </div>
            </div>
          }
        >
          {m.contribuicao.map((n: any, jindex: any) => (
            <ContribuicaoItem
              key={`ind-${jindex}`}
              evento={m}
              idEvento={controller.getId()}
              controller={controller}
              rollBackUrl={rollBackUrl}
              value={n}
            />
          ))}
        </Card>
      </>
    );
  };

  const contribuicaoPublicada = () => {
    if (
      !contribuicaoPublicadaController.lista ||
      contribuicaoPublicadaController.lista.length === 0
    ) {
      return <div>Nenhum dispostivo encontrado</div>;
    }
    return (
      <>
        {contribuicaoPublicadaController.lista.length > 0 ? (
          contribuicaoPublicadaController.lista.map((m: any, index: any) => (
            <div key={index + m.codDispositivo}>
              {contribuicaoPublicadaItem(m)}
            </div>
          ))
        ) : (
          <div className="text-center" style={{ margin: "20px 0" }}>
            Nenhum registro encontrado
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <If condition={controller.tab === "contribuicao-publicada"}>
        <Card className="evento-vis-card-tab" title="Buscar tópicos">
          <Container style={{ margin: "0" }} className="no-spaces">
            <Field className="no-spaces" col={12}>
              <InputText
                value={contribuicaoPublicadaController.filter}
                maxLength={200}
                onChange={(event) =>
                  contribuicaoPublicadaController.setFilter(event.target.value)
                }
              />
            </Field>
          </Container>
          <div className="flex justify-content-end mt-2">
            <AnttButton
              onClick={() =>
                contribuicaoPublicadaController.filtrarDispositivos()
              }
              label="Pesquisar"
            />
          </div>
        </Card>
        <div className="evento-vis-card-tab px-2">
          <div className="evento-full">{contribuicaoPublicada()}</div>
        </div>
      </If>
    </>
  );
}
